import React from 'react';
import { getModifierLabels, Hotkey } from '../../lib/hotkeys';

export const HotkeyLabels = ({ hotkeys }: { hotkeys: Hotkey[] }) => (
  <div>
    {hotkeys.map((hotkey, index) => (
      <span key={hotkey.key}>
        {`${index > 0 ? ' ' : ''}${getModifierLabels(hotkey.modifiers)}${
          hotkey.key
        }`}
      </span>
    ))}
  </div>
);
